/**
 * Short USD label for search price chips (audit rank 202): `$1.5M`, `$650K`,
 * `$900`. Exact text of the copies it replaced in SearchFilters and
 * registry-filter-chrome, so output is unchanged for every input.
 */
export function formatUsdShort(n: number): string {
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1)}M`
  if (n >= 1_000) return `$${Math.round(n / 1_000)}K`
  return `$${n}`
}
